/**
 * Utility functions for interacting with API.
 */
import _MetadataAPIConnectors from './MetadataAPIConnectors';
import _UserAPIConnectors from './UserAPIConnectors';
import _InvitationAPIConnectors from './InvitationAPIConnectors';
import _PatientAPIConnectors from './PatientAPIConnectors';
import _FileAPIConnectors from './FileAPIConnectors';
import _ForgotPasswordAPIConnectors from './ForgotPasswordAPIConnectors';
import _ActivityLogAPIConnectors from './ActivityLogAPIConnectors';
import _GetZipcodeInfo from './GetZipcodeInfo';
import _TestimonialAPIConnectors from './TestimonialAPIConnectors';
import _FPPAPIConnectors from './FPPAPIConnectors';

export const MetadataAPIConnectors = _MetadataAPIConnectors;
export const UserAPIConnectors = _UserAPIConnectors;
export const PatientAPIConnectors = _PatientAPIConnectors;
export const FileAPIConnectors = _FileAPIConnectors;
export const InvitationAPIConnectors = _InvitationAPIConnectors;
export const ForgotPasswordAPIConnectors = _ForgotPasswordAPIConnectors;
export const ActivityLogAPIConnectors = _ActivityLogAPIConnectors;
export const GetZipcodeInfo = _GetZipcodeInfo;
export const TestimonialAPIConnectors = _TestimonialAPIConnectors;
export const FPPAPIConnectors = _FPPAPIConnectors;



// WEBPACK FOOTER //
// ./src/api/index.js